// src/pages/admin/wrapper.tsx
import React from 'react';
import AdminPageWrapper from '../../components/adminpagewrapper';
import AdminHomeComponent from './home';
import AdminTournoiComponent from './tournoi';
import AdminLigueComponent from './ligue';
import AdminEpreuveComponent from './epreuve';
import AdminClubComponent from './club';
import AdminCategorieComponent from './categorie';
import AdminMailingComponent from './mailing';

// Export wrapped versions for route protection
export const AdminHome = () => (
  <AdminPageWrapper>
    <AdminHomeComponent />
  </AdminPageWrapper>
);

export const AdminTournoi = () => (
  <AdminPageWrapper>
    <AdminTournoiComponent />
  </AdminPageWrapper>
);

export const AdminLigue = () => (
  <AdminPageWrapper>
    <AdminLigueComponent />
  </AdminPageWrapper>
);

export const AdminEpreuve = () => (
  <AdminPageWrapper>
    <AdminEpreuveComponent />
  </AdminPageWrapper>
);

export const AdminClub = () => (
  <AdminPageWrapper>
    <AdminClubComponent />
  </AdminPageWrapper>
);

export const AdminCategorie = () => (
  <AdminPageWrapper>
    <AdminCategorieComponent />
  </AdminPageWrapper>
);

export const AdminMailing = () => (
  <AdminPageWrapper>
    <AdminMailingComponent />
  </AdminPageWrapper>
);
